var gl10 = require('./1.0/numbers');

module.exports = function lookupConstant(number) {
  return gl10[number];
};